import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import SalonService from "../../services/SalonService";
import moment from "moment";
import "./AppointmentDetails.css";
import GlobalLoader from "../loadingIndicator/GlobalLoader";

export default function AppointmentDetails() {

    const location = useLocation();
    const navigate = useNavigate();

    const { apntId, salonUuid } = location.state || {};

    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        fetchDetails();
    }, []);

    const fetchDetails = async () => {
        try {
            const res = await SalonService.getAppointmentById(apntId);
            setData(res.data);
        } catch (e) {
            console.error("Failed to load appointment", e);
        } finally {
            setLoading(false);
        }
    };

    if (loading) return <GlobalLoader />;

    if (!data) return <p>No data found</p>;

    return (
        <div className="appointment-details-container">

            <h2>Appointment Details</h2>

            <div className="details-card">

                <h3>{data.salonName}</h3>

                <p><strong>Status:</strong> {data.apntStatus}</p>
                <p><strong>Date:</strong> {moment(data.apntDate).format("DD/MM/YYYY")}</p>
                <p><strong>Time:</strong> {data.apntTime}</p>
                <p><strong>Services:</strong> {data.serviceNames}</p>
                {data.advanceAmount > 0 && (
                    <p><strong>Advance Paid:</strong> ₹{data.advanceAmount}</p>
                )}

            </div>

            {/* 🔥 CTA */}
            <button
                className="book-again-btn"
                onClick={() =>
                    navigate(`/booking`)
                }
            >
                🔁 Book Another Appointment
            </button>

        </div>
    );
}